import { render, staticRenderFns } from "./newAccount.vue?vue&type=template&id=77354340&scoped=true"
import script from "./newAccount.vue?vue&type=script&lang=js"
export * from "./newAccount.vue?vue&type=script&lang=js"
import style0 from "./newAccount.vue?vue&type=style&index=0&id=77354340&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77354340",
  null
  
)

export default component.exports